import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment/moment';
import { InvoiceModel } from 'app/models/invoice.model';
import { ConfigService } from 'app/services/config.service';
import { RegionType } from 'app/enums/region-type.enum';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { SurveyMetaModel, SurveyQuestionDialogModel } from 'app/core/models/survey-question-response.model';
import { MatDialog } from '@angular/material/dialog';
import { SurveyQuestionComponent } from '../../core/components/survey-question/survey-question.component';
import { SurveyQuestionDialogComponent } from '../../core/components/survey-question-dialog/survey-question-dialog.component';

@Component({
    selector: 'app-my-bill',
    templateUrl: './my-bill.component.html',
    styleUrls: ['./my-bill.component.css'],
    standalone: false
})
export class MyBillComponent implements OnInit {
    public invoice_model: InvoiceModel;
    public is_late: boolean;
    public days_until_bill_due: number;
    public breakdownToggle = false;
    public RegionType = RegionType;
    public propertyEmail;
    public faLightbulb=faLightbulb;
    public survey_enabled = false;
    public survey_submitted = false;
    public survey_question_dialog: SurveyQuestionDialogModel = new SurveyQuestionDialogModel();
    constructor(private route: ActivatedRoute, private config: ConfigService,public dialog: MatDialog) {

    }

    ngOnInit() {
        this.route.data.subscribe(({ invoice_model,survey_question_model }) => {
            this.invoice_model = invoice_model;
            const days = this.config.getCurrentMoment().startOf('day').diff(moment(this.invoice_model.date_due).startOf('day'), 'days', false);
            this.is_late = days > 0;
            this.days_until_bill_due = Math.ceil(Math.abs(days));
            this.propertyEmail = invoice_model.property_primary_contact_email;

            this.survey_enabled =invoice_model.survey_enabled;
            this.survey_question_dialog.survey_question_id = survey_question_model.id;
            this.survey_question_dialog.question_text =survey_question_model.question_text;
            const  survey_meta: Array<SurveyMetaModel> =new Array<SurveyMetaModel>();
            survey_meta.push({
             meta_type: 'invoice',
             id : this.invoice_model.id
            });
            this.survey_question_dialog.survey_meta = survey_meta;
        });
    }

    open_dialog(){
     const dialogRef= this.dialog.open(SurveyQuestionDialogComponent, {
        height:'auto',
        minWidth:'35%',
        maxWidth:'75%',
        data: this.survey_question_dialog
      });

      dialogRef.afterClosed().subscribe(result => {
        this.survey_submitted = result;
      });
    }



}
